function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -952.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m50 968.36c-3.3136 0-6 2.6863-6 6v22h-22c-3.3137 0-6 2.6862-6 6 0 3.3136 2.6863 6 6 6h22v22c0 3.3137 2.6864 6 6 6 3.3138 0 6-2.6863 6-6v-22h22c3.3137 0 6-2.6864 6-6 0-3.3138-2.6863-6-6-6h-22v-22c0-3.3137-2.6862-6-6-6z",
    color: "#000000",
    overflow: "visible",
    style: {
      blockProgression: "tb",
      textIndent: 0,
      textTransform: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.e2e6e6e36aee0ee6dcbe27b2f48f60d2.svg";
export { ForwardRef as ReactComponent };